import { ExperiencesRequest } from '@cemex-core/cmx-api';
import { createAction, props } from '@ngrx/store';
import { CxExperience } from '../../models/experience';

export const resetState = createAction('[EXPERIENCES] Reset State');
export const initEntity = createAction('[EXPERIENCES] Init Entity', props<{ id: string }>());
export const resetEntityState = createAction('[EXPERIENCES] Reset Entity', props<{ id: string }>());
export const fetchEntity = createAction('[EXPERIENCES] Fetch Entity start', props<ExperiencesRequest>());
export const updateEntity = createAction('[EXPERIENCES] Update Entity', props<{ payload: CxExperience }>());
export const updateEntities = createAction(
  '[EXPERIENCES] Update Entities',
  props<{ payload: Partial<CxExperience[]> }>(),
);
export const selectEntity = createAction('[EXPERIENCES] Select Entity', props<{ id: string }>());

export const CxExperienceActions = {
  resetState,
  resetEntityState,

  updateEntity,
  updateEntities,
  selectEntity,

  fetchEntity,
};

export default CxExperienceActions;
